export default __webpack_public_path__ + "static/media/activeArrowRight.8d7cea39.svg";